import { render, staticRenderFns } from "./EstadoSolicitud.vue?vue&type=template&id=21368cba&"
import script from "./EstadoSolicitud.vue?vue&type=script&lang=js&"
export * from "./EstadoSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports